import React from 'react';
import { Outlet } from 'react-router-dom';

function AuthLayout() {
  return (
    <div className="surface-page flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-b from-forge-50/60 to-transparent" />
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-forge-100/50 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-slate-200/40 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
}

export default AuthLayout;
